// models/posts/TadbeesaPost.js
//
// The posts the «تدبيسة النادي» page (/tadbeesa/) lists — the SAME post
// resource as the feed, kept in its OWN table.
//
// Why a separate entity and not `Post`: usePostsFeed calls `repo.flush()` on
// every reset (first load, pull-to-refresh, retry), and the home feed renders
// straight from the `Post` table. Coming back from /tadbeesa/ rebuilds home
// (with preloadPreviousPage / iosSwipeBack off, F7 removes the previous page
// after every push), and home paints its `Post` rows before its own refetch
// lands — so a shelf page reading through `Post` would hand her back the
// shelf's rows, or an empty home. Its own entity means its flush and save can
// only ever touch its own rows.
//
// Same pattern as `Bookmark extends Post` (models/Bookmark.js): every field
// declaration — including the ones that only exist because they are declared
// (`isResale`, `resaleAvailableQty`, `availability`, ...) — is inherited, so a
// card reads identically from either table. The media pivot stays separate
// too: pinia-orm stamps `mediableType` with THIS entity's name and Mediable's
// primary key includes it, so this table's photos never overwrite the feed's.
//
// Which table a card reads is decided in one place: models/posts/postFeedModels.js.
import Post from '@/models/posts/Post.js';

export default class TadbeesaPost extends Post {
  static entity = 'tadbeesaPosts';
}
